import { Alert } from "bootstrap";
import React, { Component } from "react";
import { Button, Container, Row, Col } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import "./CagnotteCollective.css";

class CagnotteCollective extends Component {
  constructor(props) {
    super(props);
    this.state = {
      document: {},
      amount: 0,
      profil: {},
    };
  }
  payoutServeur = (e) => {
    e.preventDefault();
    const data = {
      adress: this.state.adress,
      password: this.state.password,
      city: this.state.city,
      region: this.state.region,
      zip: this.state.zip,
      iban: this.state.iban,
    };

    const headers = new Headers({
      "Content-Type": "application/json",
      "X-Requested-With": "XMLHttpRequest",
      Authorization: "Bearer " + localStorage.getItem("token"),
    });

    const options = {
      method: "POST",
      body: JSON.stringify(data),
      headers: headers,
    };

    fetch(process.env.REACT_APP_BACKEND_URL + "/serveur/payout", options)
      .then((response) => {
        return response.json();
      })

      .then((responseData) => {
        this.setState({ messageTransfert: responseData.messageTransfert });
      });
  };

  change = (event) => {
    let document = this.state.document;
    document[event.target.name] = event.target.value;
    this.setState({
      document: document,
      // identifier name de l'input = choisir la valeur qui se trouve dans l'input donc necessité d'avoir le bon name!!
    });
  };
  handleInput = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };
  getWalletAmount = () => {
    const headers = new Headers({
      "Content-Type": "application/json",
      Authorization: "bearer " + localStorage.getItem("token"),
    });

    const options = {
      method: "get",

      headers: headers,
    };

    fetch(process.env.REACT_APP_BACKEND_URL + "/serveur/solde", options)
      .then((response) => {
        return response.json();
      })

      .then((responseData) => {
        this.setState({ amount: responseData });
      });
  };

  getMonProfil = () => {
    const headers = new Headers({
      Authorization: "Bearer " + localStorage.getItem("token"),
      "Content-Type": "application/json",
      "X-Requested-With": "XMLHttpRequest",
    });

    const options = {
      method: "GET",
      headers: headers,
    };

    fetch(process.env.REACT_APP_BACKEND_URL + "/serveur/monProfil", options)
      .then((response) => {
        return response.json();
      })
      .then(
        (responseObject) => {
          const monProfil = responseObject;
          this.setState({ profil: monProfil });
        },

        (error) => {
        }
      );
  };

  componentDidMount() {
    this.getWalletAmount();

    this.getMonProfil();
  }
  render() {
    return (
      <Container className="cagnotteCont">
        <Row className="rowCagn">
          <Col>
            <h1>Montant de vos pourboires :</h1>
            <h2>
              <strong>{this.state.amount / 100} euros</strong>
            </h2>
            <Button onClick={this.payoutServeur}>Retirer votre argent</Button>
            <br />
            <p>{this.state.messageTransfert}</p>
          </Col>
        </Row>
        <Row className="rowPasDeCagn">
          <Col>
            <h5 className="rappelKYC">
              {" "}
              Pas encore de cagnotte pour percevoir vos pourboires ? Suivez les
              étapes dans la partie "Mes Documents" !
            </h5>
          </Col>
        </Row>
      </Container>
    );
  }
}

export default CagnotteCollective;
